import { render } from "./FooterMini.vue?vue&type=template&id=3d931f14"
import script from "./FooterMini.vue?vue&type=script&lang=js"
export * from "./FooterMini.vue?vue&type=script&lang=js"

import "./FooterMini.vue?vue&type=style&index=0&id=3d931f14&lang=css"

import exportComponent from "E:\\项目\\弗莱德\\DL-Flight.Protal\\DL-Flight.Protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__